/** @format */

import { Resource } from '@common/application/enums/Resource';
import { AuditClient } from '@common/model/apiClient';
import { Nullable } from '@common/types/utils';
import axios from 'axios';

const uploadFileToSignedUrl = async (signedUrl: string, file: Nullable<File | string>, record: Record<string, any>, resourceAccessor: string, resource: Resource) => {
  if (!signedUrl || !file) return;

  const headers: Record<string, string> = {};

  if (file instanceof File) {
    headers['Content-Type'] = file.type || 'application/octet-stream';
  } else {
    headers['Content-Type'] = 'application/octet-stream';
  }

  await axios.put(signedUrl, file, { headers });

  await AuditClient.auditSignedUrlUpload(record, record[resourceAccessor], resource);
};

export default uploadFileToSignedUrl;
